// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"87654339","167":"898e0315","299":"5bf55ddd","488":"fef6664d","559":"19507cd4","580":"c6ed2414","812":"9809b21a","828":"c8110355","838":"de2e164b","896":"fcb085dc"}[chunkId] + ".chunk.js";
};